import React from 'react'
import { Tabs, Tab, TabList } from '@moonpig/launchpad-components'
import { styled } from '@moonpig/launchpad-utils'
import { spacingPx } from '@moonpig/launchpad-theme'

type Props<T extends { title: string }> = {
  tabs: T[]
  selectedTab: T
  onTabSelectionChanged: (selectedTab: T) => void
  ariaLabel: string
}

const StyledTabs = styled(Tabs)`
  [role='tablist'] {
    margin-top: 0;
    scrollbar-width: none;
    -webkit-overflow-scrolling: touch;
  }
`

const StyledTab = styled(Tab)`
  scroll-margin: ${spacingPx(4)};
`

export const TabCarousel = <T extends { title: string }>({
  tabs,
  selectedTab,
  onTabSelectionChanged,
  ariaLabel,
}: Props<T>) => {
  const handleValueChange = (value: string) => {
    const next = tabs.find(tab => tab.title === value)
    if (next) {
      onTabSelectionChanged(next)
    }
  }

  return (
    <StyledTabs value={selectedTab.title} onValueChange={handleValueChange}>
      <TabList variant="chip" ariaLabel={ariaLabel}>
        {tabs.map(tab => (
          <StyledTab
            key={tab.title}
            value={tab.title}
            aria-controls="product-carousel"
          >
            {tab.title}
          </StyledTab>
        ))}
      </TabList>
    </StyledTabs>
  )
}
